import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AlertBox from "../../Components/Alert";
import {
  UNIVERSITY_LIST_CREATE,
  UNIVERSITY_LIST_CREATE_RESET_FORM,
  UNIVERSITY_LIST_UPDATE,
  UNIVERSITY_LIST_UPDATE_RESET,
  UNIVERSITY_SINGLE_FORM_RESET,
} from "../../Actions/universityAction";
import {
  University_Form_Checker,
  University_form,
} from "../../Models/universityModel";

export default function CreateUniversity({
  handleFormClose,
  FormOpener,
  EditFormOpener,
  handleEditorForm,
  University_Lists_Get_Req,
  UniversityID,
}) {
  const [UniversityForm, setUniversityForm] = useState(University_form);
  const [Alert, setAlert] = useState([]);
  const [Country_data, setCountry_data] = useState([]);
  const {
    Create_University_Loading,
    Create_University_Success,
    Create_University_Error,
  } = useSelector((state) => state.UNIVERSITY_LIST_CREATE_REDUCER);
  const { Country_List } = useSelector((state) => state.COUNTRY_LIST_REDUCER);
  const { University_Single_Data } = useSelector(
    (state) => state.UNIVERSITY_SINGLE_DATA_REDUCER
  );

  const {
    Update_University_Loading,
    Update_University_Success,
    Update_University_Error,
  } = useSelector((state) => state.UNIVERSITY_LIST_UPDATE_REDUCER);

  const dispatch = useDispatch();

  const handleFormChange = (e) => {
    setUniversityForm({
      ...UniversityForm,
      [e.target.name]: e.target.value,
    });
    setAlert([]);
  };

  const handleFormCancel = () => {
    handleFormClose();
    dispatch(UNIVERSITY_LIST_CREATE_RESET_FORM());
    setAlert([]);
    setUniversityForm(University_form);
  };

  const handleEditCancel = () => {
    handleEditorForm();
    setAlert([]);
    dispatch(UNIVERSITY_SINGLE_FORM_RESET());
    dispatch(UNIVERSITY_LIST_UPDATE_RESET());
    setUniversityForm(University_form);
  };

  /*  University Web Details Create Error and Success handle start  */

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const FormCheck = University_Form_Checker(UniversityForm);
    if (FormCheck[0] === "success") {
      dispatch(UNIVERSITY_LIST_CREATE(UniversityForm));
    } else {
      setAlert(FormCheck);
    }
  };

  useEffect(() => {
    if (Create_University_Error) {
      setAlert([Create_University_Error]);
    }
    if (Create_University_Success) {
      setAlert([Create_University_Success]);

      setTimeout(() => {
        handleFormCancel();
        University_Lists_Get_Req();
      }, 1200);
    }
  }, [Create_University_Error, Create_University_Success]);

  /*  University Web Details Create Error and Success handle End */

  /*  University Web Details Edit Req Error and Success handle  */
  const handleEditFormSubmit = (e) => {
    e.preventDefault();
    for (let key in UniversityForm) {
      if (UniversityForm[key] === null) {
        UniversityForm[key] = "";
      }
    }
    const FormCheck = University_Form_Checker(UniversityForm);
    if (FormCheck[0] === "success") {
      dispatch(UNIVERSITY_LIST_UPDATE(UniversityID, UniversityForm));
    } else {
      setAlert(FormCheck);
    }
  };

  useEffect(() => {
    if (Update_University_Error) {
      setAlert([Update_University_Error]);
    }
    if (Update_University_Success) {
      setAlert([Update_University_Success]);

      setTimeout(() => {
        handleEditCancel();
        University_Lists_Get_Req();
      }, 1200);
    }
  }, [Update_University_Success, Update_University_Error]);

  /*  University Web Details Edit Req Error and Success handle End  */

  useEffect(() => {
    setCountry_data(Country_List);
  }, [Country_List]);

  useEffect(() => {
    if (EditFormOpener && University_Single_Data) {
      setUniversityForm(University_Single_Data[0]);
    } else {
      setUniversityForm(University_form);
    }
  }, [EditFormOpener, University_Single_Data]);

  return (
    <>
      <div
        id="CreatContact"
        className={
          FormOpener || EditFormOpener ? "overlay-note w100 " : "overlay-note"
        }>
        <div className="Alert">
          {" "}
          {Alert.length > 0
            ? Alert.map((el, i) => (
                <AlertBox
                  key={i}
                  alert={el}
                  validator={
                    Create_University_Success || Update_University_Success
                      ? true
                      : false
                  }
                />
              ))
            : ""}{" "}
        </div>
        <div class="overlay-add-deals contact-right-side">
          <div class="note-title">
            <h4 class="text-left text-white pl-3">
              {EditFormOpener ? "Update University" : "Create University"}
            </h4>
            <a
              className="closebtn text-right text-white"
              onClick={() => {
                EditFormOpener ? handleEditCancel() : handleFormCancel();
              }}>
              &times;
            </a>
          </div>
          <div className="contact-body modify-create-contact">
            <form
              onSubmit={
                EditFormOpener ? handleEditFormSubmit : handleFormSubmit
              }>
              <div className="form-group">
                <label>
                  University Name:<b>*</b>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter University Name"
                  name="University_Name"
                  value={UniversityForm.University_Name}
                  onChange={(e) => handleFormChange(e)}
                />
              </div>
              <div className="form-group">
                <label>
                  {"Country Name"}:<b>*</b>
                </label>
                <select
                  type="number"
                  className="form-control"
                  placeholder="Country"
                  name={"Country_Id"}
                  value={UniversityForm.Country_Id}
                  onChange={(e) => handleFormChange(e)}>
                  <option value="">Select Country</option>
                  {Country_data?.map((el) => (
                    <option key={el.Id} value={el.Id}>
                      {el.Country}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>{"World Ranking"}:</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter World Ranking"
                  name={"World_Ranking"}
                  value={UniversityForm.World_Ranking}
                  onChange={(e) => handleFormChange(e)}
                />
              </div>
              <div className="form-group">
                <label>{"Country Ranking"}:</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter Country Ranking"
                  name={"Country_Ranking"}
                  value={UniversityForm.Country_Ranking}
                  onChange={(e) => handleFormChange(e)}
                />
              </div>
              <div className="form-group">
                <label>{"University Address"}:</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter University Address"
                  name={"University_Address"}
                  value={UniversityForm.University_Address}
                  onChange={(e) => handleFormChange(e)}
                />
              </div>
              <div className="form-group">
                <label>{"Affiliation"}:</label>
                <select
                  type="number"
                  className="form-control"
                  placeholder="Affiliation"
                  name={"Affiliation"}
                  value={UniversityForm.Affiliation}
                  onChange={(e) => handleFormChange(e)}>
                  <option value="">Select Affiliation</option>
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </select>
              </div>
              <div className="form-group">
                <label>{"Affiliation Pathway"}:</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Affiliation Pathway"
                  name={"Affiliation_Pathway"}
                  value={UniversityForm.Affiliation_Pathway}
                  onChange={(e) => handleFormChange(e)}
                />
              </div>
              <div className="form-group">
                <label>{"Contact Person"}:</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Contact Person"
                  name={"Contact_Person"}
                  value={UniversityForm.Contact_Person}
                  onChange={(e) => handleFormChange(e)}
                />
              </div>
              <div className="form-group">
                <label>{" Contact Number"}:</label>
                <input
                  type="phone"
                  className="form-control"
                  placeholder="Enter Contact Number"
                  name={"Contact_Number"}
                  value={UniversityForm.Contact_Number}
                  onChange={(e) => handleFormChange(e)}
                />
              </div>
              <div className="form-group">
                <label>{"Contact Email"}:</label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Enter Contact Email"
                  name={"Contact_Email"}
                  value={UniversityForm.Contact_Email}
                  onChange={(e) => handleFormChange(e)}
                />
              </div>
              <div className="form-group">
                <label>{"Commision Percentage PG"}:</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Commision Percentage PG"
                  name={"Commision_Percentage_PG"}
                  value={UniversityForm.Commision_Percentage_PG}
                  onChange={(e) => handleFormChange(e)}
                />
              </div>
              <div className="form-group">
                <label>{"Commision Including GST"}:</label>
                <select
                  type="number"
                  className="form-control"
                  placeholder="Commision Including GST"
                  name={"Commision_Including_GST"}
                  value={UniversityForm.Commision_Including_GST}
                  onChange={(e) => handleFormChange(e)}>
                  <option value="">Select Commision Including GST</option>
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </select>
              </div>
              <div className="form-group">
                <label>{"Commission Duration"}:</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Commission Duration"
                  name={"Commission_Duration"}
                  value={UniversityForm.Commission_Duration}
                  onChange={(e) => handleFormChange(e)}
                />
              </div>
              <div className="form-group">
                <label>{"Lumpsum Commision"}:</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Lumpsum Commision"
                  name={"Lumpsum_Commision"}
                  value={UniversityForm.Lumpsum_Commision}
                  onChange={(e) => handleFormChange(e)}
                />
              </div>
              <div className="form-group">
                <label>{"Attachment Name"}:</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Attachment Name"
                  name={"Attachment_Name"}
                  value={UniversityForm.Attachment_Name}
                  onChange={(e) => handleFormChange(e)}
                />
              </div>
              <div className="form-group">
                <label>{"Commision Percentage UG"}:</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Commision Percentage UG"
                  name={"Commision_Percentage_UG"}
                  value={UniversityForm.Commision_Percentage_UG}
                  onChange={(e) => handleFormChange(e)}
                />
              </div>
              <div className="form-group">
                <label>{"Commision Percentage Other"}:</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Commision Percentage Other"
                  name={"Commision_Percentage_Other"}
                  value={UniversityForm.Commision_Percentage_Other}
                  onChange={(e) => handleFormChange(e)}
                />
              </div>
              <div className="form-group">
                <label>{"Partnership"}:</label>
                <select
                  type="number"
                  className="form-control"
                  placeholder="Enter Partnership"
                  name={"Partnership"}
                  value={UniversityForm.Partnership}
                  onChange={(e) => handleFormChange(e)}>
                  <option value="">Select Partnership</option>
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </select>
              </div>
              <div className="contact-footer w-100">
                {EditFormOpener ? (
                  <button
                    type="submit"
                    disabled={Update_University_Loading}
                    class="btn">
                    {Update_University_Loading
                      ? "Loading.."
                      : "Update University"}
                  </button>
                ) : (
                  <button
                    type="submit"
                    disabled={Create_University_Loading}
                    className="btn">
                    {Create_University_Loading
                      ? "Loading..."
                      : "Create University"}
                  </button>
                )}

                <button
                  type="button"
                  className="btn btn-deep-orange waves-effect waves-light"
                  onClick={() => {
                    EditFormOpener ? handleEditCancel() : handleFormCancel();
                  }}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
